import { FIT_BANDS } from "../../constant";
import { getTraitBand } from "../../oprations";

/**
 * The web report's tiers (the 4.0 hiring report's): production's own bands,
 * read against each score's bounds, under 4.0's names and tones.
 */
const TIER_BY_BAND = new Map([
  [FIT_BANDS.HIGHLY, "expert"],
  [FIT_BANDS.RECOMMENDED, "proficient"],
  [FIT_BANDS.CAUTIOUSLY, "developing"],
  [FIT_BANDS.NOT, "beginner"],
]);

/**
 * @param {object} bounds {score, lb, ub, median} as getTraitBand takes them
 * @returns {{ tier: string, label: string }} tier is "none" when there is no score
 */
export const tierOf = ({ score, lb, ub, median }) => {
  if (score == null || Number.isNaN(Number(score))) return { tier: "none", label: "" };
  const band = getTraitBand({ score, lb, ub, median });
  return { tier: TIER_BY_BAND.get(band) ?? "none", label: band?.label ?? "" };
};
